import { render, staticRenderFns } from "./mPages.vue?vue&type=template&id=32788d19&scoped=true"
import script from "./mPages.vue?vue&type=script&lang=js"
export * from "./mPages.vue?vue&type=script&lang=js"
import style0 from "./mPages.vue?vue&type=style&index=0&id=32788d19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32788d19",
  null
  
)

export default component.exports